import React from 'react';

import { withUAPLThemedStyles } from '../../with-themed-styles';
import { ResponsiveAdPlacementMmaBase } from './responsive-mma-ad-placement-base';
import {
  getResponsiveMmaVerticalImage1x2Styles,
  getResponsiveMmaSquareImage1x1Styles,
  getResponsiveMmaLandScapeImage191x100Styles,
  getResponsiveMmaWideImage4x1Styles,
} from '../../styles';

export const ResponsiveAdPlacementMmaWideImage4x1 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof ResponsiveAdPlacementMmaBase>) => (<ResponsiveAdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl
    showDescription
    showCallToAction
    showAdLabel
    showGradient
    showBusinessName={false}
  />),
  getResponsiveMmaWideImage4x1Styles,
  { componentName: 'AdPlacementMmaWideImage4x1' }
);

export const ResponsiveAdPlacementMmaLandscapeImage191x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof ResponsiveAdPlacementMmaBase>) => (<ResponsiveAdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl
    showDescription
    showCallToAction
    showAdLabel
    showGradient={false}
    showBusinessName={false}
    showLogo
  />),
  getResponsiveMmaLandScapeImage191x100Styles,
  { componentName: 'AdPlacementMmaLandscapeImage191x100' }
);

export const ResponsiveAdPlacementMmaSquareImage1x1 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof ResponsiveAdPlacementMmaBase>) => (<ResponsiveAdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl
    showDescription
    showCallToAction
    showAdLabel
    showGradient
    showBusinessName={false}
  />),
  getResponsiveMmaSquareImage1x1Styles,
  { componentName: 'AdPlacementMmaSquareImage1x1' }
);

export const ResponsiveAdPlacementMmaVerticalImage1x2 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof ResponsiveAdPlacementMmaBase>) => (<ResponsiveAdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl
    showDescription
    showCallToAction
    showAdLabel
    showGradient
    showBusinessName={false}
  />),
  getResponsiveMmaVerticalImage1x2Styles,
  { componentName: 'AdPlacementMmaVerticalImage1x2' }
);
